<template>
  <BaseModal col-md="col-md-6" offset="3"
             :subtitulo="tabSelect === 'info' ? 'Informações da análise' : 'Editar análise'"
             :modalColor="tabSelect === 'info' ? 'border-primary bg-success' : 'border-warning bg-warning'">
    <template v-slot:modalContent>
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" :class="tabSelect === 'info' ? 'active' : ''" data-toggle="tab" href="#tab-1"
            >Informações</a>
          </li>
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" data-toggle="tab" href="#tab-2"
            >Documentos</a>
          </li>
          <li v-if="tabSelect === 'info'">
            <a class="nav-link" data-toggle="tab" href="#tab-3"
            >Imagens</a>
          </li>
          <li v-if="tabSelect === 'edit'">
            <a class="nav-link" :class="tabSelect === 'edit' ? 'active' : ''" data-toggle="tab" href="#tab-4"
            >Editar análise</a>
          </li>
          <li v-if="tabSelect === 'edit'">
            <a class="nav-link" data-toggle="tab" href="#tab-5"
            >Alterar fase</a>
          </li>
          <li>
            <a class="nav-link" data-toggle="tab" href="#tab-6"
            >Histórico das fases</a>
          </li>
        </ul>
        <div class="tab-content">
          <div v-if="tabSelect === 'info'" id="tab-1" class="tab-pane" :class="tabSelect === 'info' ? 'active' : ''">
            <div class="panel-body">
              <InformacoesAnalise
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
          <div v-if="tabSelect === 'info'" id="tab-2" class="tab-pane">
            <div class="panel-body">
              <DocumentosAnalise
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
          <div v-if="tabSelect === 'info'" id="tab-3" class="tab-pane">
            <div class="panel-body">
              <ImagensAnalise
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>

          <div v-if="tabSelect === 'edit'" id="tab-4" class="tab-pane" :class="tabSelect === 'edit' ? 'active' : ''">
            <div class="panel-body">
              <EditarAnalise
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
                  @atualizarDados="$emit('atualizarDados', $event)"
              />
            </div>
          </div>
          <div v-if="tabSelect === 'edit'" id="tab-5" class="tab-pane">
            <div class="panel-body">
              <AlterarFase
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
                  @atualizaStatus="$emit('atualizaStatus', $event)"
              />
            </div>
          </div>
          <div id="tab-6" class="tab-pane">
            <div class="panel-body">
              <HistoricoFase
                  :itemKey="itemKey"
                  @fechar="$emit('fechar')"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import InformacoesAnalise from './InformacoesAnalise.vue';
import EditarAnalise from './EditarAnalise.vue';
import DocumentosAnalise from "./DocumentosAnalise.vue";
import ImagensAnalise from "./ImagensAnalise.vue";
import HistoricoFase from "./HistoricoFases.vue";
import AlterarFase from "./AlterarFase.vue";

export default {
  name: "TabsModalAnalise",
  components: {
    BaseModal,
    InformacoesAnalise,
    EditarAnalise,
    DocumentosAnalise,
    ImagensAnalise,
    HistoricoFase,
    AlterarFase,
  },
  props: {
    itemKey: String,
    tabSelect: String,
  },
  emits: ['fechar', 'atualizaStatus', 'atualizarDados'],
};
</script>
